import React from "react";
import {
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
  Row
} from "react-bootstrap";

import ButtonLoader from "../../../ButtonLoader";
import ShowNotification from "../../../Notification/LoadableShowNotification";

function LoginForm(props) {
  const {
    showSsoLoginForm,
    showLoginButton,
    showNextButton,
    loginError,
    isLoading,
    emailError,
    closeLoginError,
    closeEmailError,
    domainError,
    closeDomainError,
    downLoadError,
    closeDownloadError,
    loginType,
    login,
    formSubmitted,
    errors,
    showForm,
    handleInputChange,
    handleNextButton,
    handleChangeEmail,
    handleCheck,
    rememberMe,
    sso,
    ssoLogin,
    onSocialLogin,
    isSsoExist,
    closeSsoError
  } = props;

  return (
    showSsoLoginForm && (
      <React.Fragment>
        <div className="Login">
          {!!!loginType && (
            <div className="signup-form">
              <section id="TermsAndConditions-sso">
                <span>Sign in with your single sign-on credentials</span>
              </section>
            </div>
          )}
          {/* {!isSsoExist && (
            <ShowNotification
              closeError={closeSsoError}
              errorHeading={`SSO configuration error`}
              errorDesc={`SSO is not configured for this account`}
            />


          )} */}

          {emailError && (
            <ShowNotification
              closeError={closeEmailError}
              errorHeading={`Invalid details!`}
              errorDesc={`Email address is incorrect. Please try again.`}
            />
          )}

          {domainError && (
            <ShowNotification
              closeError={closeDomainError}
              errorHeading={`Invalid redirect URL.`}
              errorDesc={`Please provide correct redirect URL.`}
            />
          )}

          {downLoadError && (
            <ShowNotification
              closeError={closeDownloadError}
              errorHeading={`You don't have access to this account.`}
              errorDesc={`Seems you are not an authorized user for this account.`}
            />
          )}

          <section className="login-form mar_pointt">
            {!isSsoExist && (
              <div className="error--box">
                <h4>SSO configuration error</h4>
                <p>SSO is not configured for this account.</p>
              </div>
            )}
            {!!(!loginType || loginType === 2) && (
              <Row>
                <form onSubmit={login} id="login-form" method="post">
                  <FormGroup
                    controlId="email"
                    validationState={
                      formSubmitted
                        ? errors.email
                          ? "error"
                          : "success"
                        : null
                    }
                  >
                    <ControlLabel>
                      Email Address <span className="star">*</span>
                    </ControlLabel>
                    <FormControl
                      className="email-field"
                      type="text"
                      // name="email"
                      name="txtEmail"
                      // placeholder="Enter your email address"
                      onChange={handleInputChange}
                      // disabled={!showNextButton && !loginType}
                    />
                    {errors.email && <HelpBlock>{errors.email}</HelpBlock>}
                    {/* {!showNextButton && !loginType && (
                      <span
                        className="change-email"
                        onClick={() => handleChangeEmail()}
                      >
                        Change
                      </span>
                    )} */}
                    {showNextButton && (
                      <Button
                        type="button"
                        className="btn-style next-btn-login"
                        onClick={() => handleNextButton(true)}
                      >
                        <span className="text-name">Next</span>
                        <span className="text-next-arrow">
                          {" "}
                          <img
                            src={require("../../../../images/right-arrow-white.svg")}
                            alt="next"
                          />
                        </span>
                        {isLoading && <ButtonLoader />}
                      </Button>
                    )}
                  </FormGroup>
                </form>
              </Row>
            )}
          </section>

          {!!(!loginType || loginType === 2) &&
            !window.location.search.includes("webex") && (
              <footer>
                <div>
                  <section id="lineORline" className="remove-mar">
                    <Row>
                      <div className="different-method-container">
                        <a
                          href="javascript:;"
                          className="different-method-link"
                          onClick={() => showForm("login")}
                        >
                          Sign in using a different method
                        </a>
                      </div>
                    </Row>
                  </section>
                </div>
              </footer>
            )}
        </div>
      </React.Fragment>
    )
  );
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/Login/SubComponents/SsoLoginForm/SsoLoginForm.js